import { monthOf, monthBounds } from './dateUtils';

/**
 * The Finance filters widened just enough to show a record that was just
 * created: its currency, and start/end dates stretched to its date. Returns
 * the same `filters` object when the record already shows, so the caller can
 * tell whether anything changed.
 *
 * Dates are compared as "YYYY-MM-DD" strings. new Date("YYYY-MM-DD") is UTC
 * midnight, which at UTC-3 is the previous day.
 */
export const filtersIncluding = (filters, { date, currency }) => {
  const day = String(date || '').slice(0, 10);
  const next = { ...filters };
  if (currency && filters.currency && currency !== filters.currency) next.currency = currency;
  if (day && filters.start_date && day < filters.start_date) next.start_date = day;
  if (day && filters.end_date && day > filters.end_date) next.end_date = day;
  const changed = Object.keys(next).some((k) => next[k] !== filters[k]);
  return changed ? next : filters;
};

/**
 * The same, when Finance works month by month: a record dated in another
 * month moves the filters to that whole month (first to last day) instead of
 * stretching the range. Its currency is taken too. Same object if nothing
 * changes.
 */
export const monthFiltersIncluding = (filters, { date, currency }) => {
  const month = monthOf(date);
  const next = { ...filters };
  if (currency && filters.currency && currency !== filters.currency) next.currency = currency;
  if (month && month !== monthOf(filters.start_date)) {
    const { start, end } = monthBounds(month);
    next.start_date = start;
    next.end_date = end;
  }
  const changed = Object.keys(next).some((k) => next[k] !== filters[k]);
  return changed ? next : filters;
};
